module.exports = __webpack_public_path__ + "img/4.76d33acb.jpg";